import type { TScreenOrientation, TScreenRotation } from '@/services/ScreenService'

/**
 * Tailwind class object for the player’s logical viewport (orientation swap + rotation).
 * Matches idle chrome (`WaitingBufferScreen`), quota screen, and teleported overlays (`ShowMeOverlay`).
 */
export function playerViewportRotationClassObject(
  rotation: TScreenRotation,
  orientation: TScreenOrientation
): Record<string, boolean> {
  return {
    // Pin for 90°/270° transform-origin math (absolute idle/quota/show-me shells).
    'top-0 left-0': true,
    'h-screen w-screen': orientation === 'horizontal',
    'h-[100vw] w-[100vh]': orientation === 'vertical',
    'rotate-90 origin-bottom-left -translate-y-full': rotation === '90',
    'rotate-180': rotation === '180',
    '-rotate-90 origin-top-right -translate-x-full': rotation === '270'
  }
}
